import { render, staticRenderFns } from "./Charkilla.vue?vue&type=template&id=f8b73fc8&scoped=true&"
import script from "./Charkilla.vue?vue&type=script&lang=js&"
export * from "./Charkilla.vue?vue&type=script&lang=js&"
import style0 from "./Charkilla.vue?vue&type=style&index=0&id=f8b73fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b73fc8",
  null
  
)

export default component.exports